module.exports = __webpack_public_path__ + "img/team3.ac3ee933.png";